import {$getSelection, $isRangeSelection, LexicalCommand, LexicalEditor} from 'lexical';
import {$patchStyleText} from '@lexical/selection';

import {FONT_SIZE, LINE_HEIGHT} from '../constants';

export const createDispatchCommandWithoutPayload =
    (editor: LexicalEditor) => (command: LexicalCommand<void>) =>
        editor.dispatchCommand(command, null);

export const createDispatchCommand =
    (editor: LexicalEditor) =>
        <T>(command: LexicalCommand<T>, payload: T): void => {
            editor.dispatchCommand(command, payload);
        };

export const addPx = (value: number | string) => `${value}px`;

export const createUpdateFontSize = (editor: LexicalEditor) => (newFontSize: string) =>
    editor?.update(() => {
        const selection = $getSelection();
        if ($isRangeSelection(selection)) {
            $patchStyleText(selection, {
                [FONT_SIZE]: addPx(newFontSize),
                [LINE_HEIGHT]: addPx(`${parseInt(newFontSize, 10) * 1.5}`)
            });
        }
    });
